module.exports = __webpack_public_path__ + "static/media/Play2.f96144b9.svg";